import { defineStore } from 'pinia';
import { type UserDto, UserType } from '~/dto/user';

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | undefined>(undefined);
  const refreshToken = ref<string | undefined>(undefined);
  const user = ref<UserDto | undefined>(undefined);

  const authenticated = computed(() => !!(token.value && user.value));
  const isAdmin = computed(() => ((user.value?.type ?? 0) & UserType.admin) === UserType.admin);

  return {
    token,
    refreshToken,
    user,
    authenticated,
    isAdmin,
  };
}, {
  persist: {
    pick: ['token', 'refreshToken', 'user'],
  }
});
